export const URL_TARJETAS_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarTarjetasDashboard";
export const URL_TOP10_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarTop10Dashboard";
export const URL_CLIENTES_AUTOCOMPLETE =
  "/Cxc/WebService/CxcWebService.asmx/BuscarListadoClientes";
export const URL_CLIENTES_GRID_DASHBOARD =
  "/Cxc/WebService/CxcWebService.asmx/buscarClientesGrid";

export const URL_EXPORT_CLIENTES_GRID_DASHBOARD =
    "/Cxc/WebService/CxcWebService.asmx/ExportarClientesGrid";

export const URL_GRAFICO_FACTURAS = 
    "/Facturacion/WebService/FacturacionWebService.asmx/CxcDashboardFacturasGrafico"
export const URL_GRAFICO_FACTURAS_DESCUENTO =
    "/Facturacion/WebService/FacturacionWebService.asmx/CxcDashboardFacturasDescuentoGrafico"
export const URL_GRAFICO_TASAS =
    "/CxC/WebService/CxcWebService.asmx/CxcTasasGrafico"
export const URL_GRAFICO_NOTAS_CREDITO =
    "/CxC/WebService/CxcWebService.asmx/buscarNotasCreditoCxcDashboard"
export const URL_GRAFICO_NOTAS_DEBITO =
    "/CxC/WebService/CxcWebService.asmx/buscarNotasDebitoCxcDashboard"
export const URL_GRAFICO_ANTICIPOS =
    "/CxC/WebService/CxcWebService.asmx/buscarAnticiposCxcDashboard"
export const URL_GRAFICO_RECIBOS =
    "/CxC/WebService/CxcWebService.asmx/buscarRecibosCxcDashboard"
export const URL_GRAFICO_NOTAS_CREDITO_DEVOLUCION =
    "/CxC/WebService/CxcWebService.asmx/buscarNotasCreditoDevolucionCxcDashboard"
  
